import * as React from "react";
import Moveable, { MoveableManagerInterface, Renderer } from "react-moveable";
import MoveableHelper from "moveable-helper";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { poly, star, be } from "shape-svg";
import ImageUploader from "./components/ImageUploader";

const DimensionViewable = {
  name: "dimensionViewable",
  props: {},
  events: {},
  render(moveable, React) {
    const rect = moveable.getRect();
    // Add key (required)
    // Add class prefix moveable-(required)
    return (
      <div
        key={"dimension-viewer"}
        className={"moveable-dimension"}
        style={{
          position: "absolute",
          left: `${rect.width / 2}px`,
          top: `${rect.height + 20}px`,
          background: "#4af",
          borderRadius: "2px",
          padding: "2px 4px",
          color: "white",
          fontSize: "13px",
          whiteSpace: "nowrap",
          fontWeight: "bold",
          willChange: "transform",
          transform: "translate(-50%, 0px)",
        }}
      >
        {Math.round(rect.offsetWidth)} x {Math.round(rect.offsetHeight)}
        {/* <img
          src="https://images.unsplash.com/photo-1575089976121-8ed7b2a54265?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8ZGV2ZWxvcGVyfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
          alt=""
          style={{width: rect.width,
          height: rect.height}}
        /> */}
      </div>
    );
  },
};

const NewCanvas = () => {
  const [helper] = React.useState(() => {
    return new MoveableHelper();
  });
  const targetRef = React.useRef(null);
  const [target, setTarget] = React.useState();
  const [frame, setFrame] = React.useState({
    translate: [100, 100],
    rotate: 0,
    transformOrigin: "50% 50%",
  });

  React.useEffect(() => {
    setTarget(document.querySelector(".target"));
  }, []);

  return (
    <div className="container">
      <div className="target">
        {/* <img
          src="https://images.unsplash.com/photo-1575089976121-8ed7b2a54265?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8ZGV2ZWxvcGVyfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
          alt=""
          ref={targetRef}
          style={{width:300, height:300}}
        /> */}
        {/* <input
          type="text"
          value="WElcome to text component"
          style={{ width: 400, padding: 16, fontSize: 60 }}
          ref={targetRef}
        /> */}
        <p ref={targetRef} style={{fontSize: 30}}> WElcome to text component</p>
      </div>
      <Moveable
        target={targetRef}
        ables={[DimensionViewable]}
        props={{
          dimensionViewable: true,
        }}
        draggable={true}
        resizable={true}
        scalable={true}
        rotatable={true}
        keepRatio={false}
        onDragStart={helper.onDragStart} 
        onDrag={helper.onDrag}
        onResizeStart={helper.onResizeStart}
        onResize={helper.onResize}
        onRotateStart={helper.onRotateStart}
        onRotate={helper.onRotate}
      />
    </div>

    // <TransformWrapper
    //   defaultScale={1}
    //   defaultPositionX={0}
    //   defaultPositionY={0}
    // >
    //   {({ zoomIn, zoomOut, resetTransform, positionY, ...rest }) => {
    //     return (
    //       <TransformComponent>
    //         <section className="main--container">
    //           <img
    //             src="https://images.unsplash.com/photo-1604307743907-df8d5fe9f1de?ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8d29ya3N0YXRpb258ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60"
    //             alt=""
    //           />
    //           <div className="target">Target</div>
    //           <Moveable
    //             target={target}
    //             originDraggable={true}
    //             originRelative={true}
    //             draggable={true}
    //             throttleDrag={0}
    //             startDragRotate={0}
    //             throttleDragRotate={0}
    //             zoom={1}
    //             origin={true}
    //             padding={{ left: 0, top: 0, right: 0, bottom: 0 }}
    //             rotatable={true}
    //             throttleRotate={0}
    //             rotationPosition={"top"}
    //             onDragOriginStart={(e) => {
    //               e.dragStart && e.dragStart.set(frame.translate);
    //             }}
    //             onDragOrigin={(e) => {
    //               frame.translate = e.drag.beforeTranslate;
    //               frame.transformOrigin = e.transformOrigin;
    //             }}
    //             onDragStart={(e) => {
    //               e.set(frame.translate);
    //             }}
    //             onDrag={(e) => {
    //               frame.translate = e.beforeTranslate;
    //             }}
    //             onRotateStart={(e) => {
    //               e.set(frame.rotate);
    //             }}
    //             onRotate={(e) => {
    //               frame.rotate = e.beforeRotate;
    //             }}
    //             onRender={(e) => {
    //               const { translate, rotate, transformOrigin } = frame;
    //               e.target.style.transformOrigin = transformOrigin;
    //               e.target.style.transform =
    //                 `translate(${translate[0]}px, ${translate[1]}px)` +
    //                 ` rotate(${rotate}deg)`;
    //             }}
    //             // onResize={({
    //             //   target,
    //             //   width,
    //             //   height,
    //             //   dist,
    //             //   delta,
    //             //   direction,
    //             //   clientX,
    //             //   clientY,
    //             // }) => {
    //             //   console.log("onResize", target);
    //             //   console.log("onResize", delta);
    //             //   console.log("onResize", width, height);
    //             //   delta[0] && (target.style.width = `${width}px`);
    //             //   delta[1] && (target.style.height = `${height}px`);
    //             //   onChangeMoveable(properties.id, {
    //             //     ...properties,
    //             //     width: width,
    //             //     height: height,
    //             //   });
    //             //   setTempProps({});
    //             // }}
    //           />
    //         </section>
    //       </TransformComponent>
    //     );
    //   }}
    // </TransformWrapper>
  );
};

export default NewCanvas;

// export default function NewCanvas() {
//   const [target, setTarget] = React.useState();
//   const [frame, setFrame] = React.useState({
//     translate: [100, 100],
//     rotate: 0,
//     transformOrigin: "50% 50%",
//   });
//   React.useEffect(() => {
//     setTarget(document.querySelector(".target"));
//   }, []);
//   return (
//     <div className="container-drag">
//
//     </div>
//   );
// }
